/**
* Created by lobin on 2020/7/31.
*/
<template>
	<div class="resource">
		<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
			<a-button type="primary" class="editable-add-btn" @click="handleAdd">
				添加
			</a-button>
			<a-divider />
			<a-table
				:loading="loading"
				:columns="columns"
				:data-source="list"
				size="middle"
				:scroll="{y: 600 }"
				>
				<span slot="action" slot-scope="text, record">
          <a @click="modify(record)">修改</a>
        </span>
				<span slot="status" slot-scope="text">
					<a-tag color="#87d068" v-if="text">在用</a-tag>
					<a-tag color="#f50" v-else>禁用</a-tag>
        </span>
			</a-table>
		</a-card>
		<a-modal
			:title="editType === 'add' ? '添加资源' : '编辑资源'"
			:visible="visible"
			:confirm-loading="submiting"
			@ok="handleOk"
			@cancel="handleCancel"
		>
			<a-form-model
				ref="ruleForm"
				:model="form"
				:rules="rules"
				:label-col="labelCol"
				:wrapper-col="wrapperCol"
			>
				<a-form-model-item label="资源名称" prop="name">
					<a-input v-model="form.name" placeholder="输入资源名称" />
				</a-form-model-item>
				<a-form-model-item label="资源key" prop="key">
					<a-input v-model="form.key" placeholder="输入资源key" />
				</a-form-model-item>
				<a-form-model-item label="资源类型" prop="type">
					<a-radio-group v-model="form.type">
						<a-radio value="page">page</a-radio>
						<a-radio value="action">action</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="路由" prop="route">
					<a-input v-model="form.route" placeholder="输入路由" />
				</a-form-model-item>
				<a-form-model-item label="方法" prop="method">
					<a-radio-group v-model="form.method">
						<a-radio :value="method" v-for="method in methods" :key="method">{{ method }}</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="是否可用" prop="status">
					<a-switch v-model="form.status" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script type="text/babel">
import { getResource, createResource, updateResource } from '@/api/settings';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      id: '',
      form: {},
      search: {},
      list: [],
      loading: false,
      submiting: false,
      editType: 'add',
	    visible: false,
	    labelCol: { span: 4 },
	    wrapperCol: { span: 20 },
    };
  },
  created() {
    this.getList();
  },
  computed: {
  	...mapGetters(['methods']),
    columns() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          customRender: (text, row, index) => index + 1,
          key: 'index',
          width: '50px',
        },
			  {
				  title: '名称',
				  dataIndex: 'name',
				  key: 'name',
			  },
			  {
				  title: '资源key',
				  dataIndex: 'key',
          width: 160,
				  key: 'key',
			  },
			  {
				  title: '类型',
				  dataIndex: 'type',
				  key: 'type',
			  },
			  {
				  title: '路由',
				  dataIndex: 'route',
          width: 300,
				  key: 'route',
			  },
			  {
				  title: '方法',
				  dataIndex: 'method',
				  key: 'method',
			  },
			  {
				  title: '状态',
				  dataIndex: 'status',
				  key: 'status',
		      scopedSlots: { customRender: 'status' },
			  },
			  // {
        //   title: '创建时间',
        //   dataIndex: 'ctime',
        //   key: 'ctime',
			  // },
			  {
				  title: '操作',
				  key: 'action',
				  fixed: 'right',
				  width: 100,
				  scopedSlots: { customRender: 'action' },
			  },
		  ];
    },
	  rules() {
    	return {};
	  },
  },
  methods: {
    async getList() {
      this.loading = true;
      const { data } = await getResource(this.search);
      this.list = data;
      this.loading = false;
    },
    async create() {
      this.submiting = true;
      const { data } = await createResource(this.form);
      if (data) {
        this.$message.success('提交成功');
      }
      this.submiting = false;
    },
    async update() {
    	this.submiting = true;
    	const { data } = await updateResource(this.id, this.form);
    	if (data) {
    		this.$message.success('提交成功');
	    }
    	this.submiting = false;
    },
	  handleAdd() {
	    this.editType = 'add';
	    this.visible = true;
	  },
	  modify(data) {
	    this.editType = 'edit';
	    this.form = data;
	    this.id = data._id;
	    this.visible = true;
	  },
	  async handleOk() {
    	if (this.editType === 'add') {
    		await this.create();
	    } else {
	      await this.update();
	    }
    	this.visible = false;
    	this.getList();
	  },
	  handleCancel() {
    	this.form = {};
    	this.visible = false;
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.resource {

	}
</style>
